module.exports = __webpack_public_path__ + "static/media/how2.de6da561.svg";